import { AbstractPeriodStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./InterventiActions";
import { InterventoDto } from "../generated";
import Period from "../common/period";

class InterventiReportStore extends AbstractPeriodStore<InterventoDto>{
    constructor() {
        super(x => x.idIntervento.toString(), x => x.dataIntervento);
        Dispatcher
            .onfunction(Actions.getReportInterventi, ({ from, to, interventi }) => this.setForPeriod(Period.Create(from, to), interventi))
            .onfunction(Actions.add, item => this.add(item))
            .onfunction(Actions.update, item => this.update(item))
            ;
    }


}

export default new InterventiReportStore()
